import { AppHelper } from "../appHelper"
import { AppBaseProps, CommonApp, Context } from "../core/components/commonApp";
import { DialogHelper } from "../core/util/dialogHelper";
import { Config } from "../core/config/config";
import { Helper } from "../core/util/helper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { NotificationHelper } from "../core/util/notificationHelper";
import React from "react";

export default class ShortCutInfo extends React.Component<ShortCutInfoProps, any> {
    common = new AppHelper();
    translations = [];

    constructor(props) {
        super(props);
        this.common.init(this);
        this.props.context.translations = this.translations;
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    changeOpeningMode = async () => {
        const buttons = [{
                label: this.translations["WebSMS.Help.ShortCuts.SameTab"],
                value: "0",
                primary: (!Config.user.openHotKeyInNewTab)
            }, {
                label: this.translations["WebSMS.Help.ShortCuts.NewTab"],
                value: "1",
                primary: (Config.user.openHotKeyInNewTab)
            }
        ];

        const value = await DialogHelper.choose(this.translations["WebSMS.Help.ShortCuts.HowToOpen"], buttons, true, 600);
        if (!Helper.isNullOrEmpty(value)) {
            let result = await HTTPService.get<JsonResultClass>("UserSettingsLookup/ChangeHotKeyOpeningMode?mode=" + value);
            if (result.Code === 0) {
                NotificationHelper.showSuccessMessage(result.Message);
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        }
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return (
            <>
                <CommonApp {...props} />
            </>
        );
    }
}

export interface ShortCutInfoProps extends AppBaseProps {
    context: ShortCutContext;
}

export interface ShortCutContext extends Context {
    translations?: Array<string>;
}

export interface ShortCutInfoState {
    context: ShortCutContext;
}